import React from 'react';
import logo from './logo.svg';
import './App.css';

import Header from './Header';
import Anchor, { SECTIONS, scrollTo } from './Anchor';

import HeaderSlider from './HeaderSlider';
import Spreader from './Spreader';
import TextBlock from './TextBlock';
// import SpeedTestOld from './SpeedTestOld';
import SpeedTest from './SpeedTest';
import History from './History';
import Image from './Image';
import Technologies from './Technologies';
import Footer from './Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <HeaderSlider />
      <Anchor section={SECTIONS.FUTEURE_COMMING} />
      <Spreader>
        <TextBlock title="5G – больше, чем очень быстрый интернет">
          5G — предел существующих технологий микроэлектроники и передачи
          данных. Это не просто «быстро», а быстрее, чем когда-либо было прежде.
          И речь не только об ускорении мобильного интернета и улучшении
          качества связи. 5G предложит решение таких критически важных задач,
          как дистанционное управление инфраструктурой и городским хозяйством,
          медицинскими процедурами и транспортом. Кроме того, новое поколение
          телекоммуникаций откроет новые возможности в промышленности, сельском
          хозяйстве, образовании, развлечениях и многом другом – все это будет
          работать на базе 5G. В партнерстве с МегаФоном “Ъ” представляет
          спецпроект о пятом поколении связи 5G. В интервью с генеральным
          директором компании{' '}
          <a onClick={() => scrollTo(SECTIONS.INTERVIEW)}>
            Геворком Вермишяном
          </a>
          , а также на конкретных примерах работы нового поколения связи мы
          расскажем о настоящей революции в телекоммуникациях, которая может
          изменить мир.
        </TextBlock>
      </Spreader>
      <br />
      <br />
      <Anchor section={SECTIONS.HISTORY_PROGRESS} />
      <History />
      <Anchor section={SECTIONS.TECHNOLOGIES} />
      <Technologies />

      <Anchor section={SECTIONS.SPEED} />
      <SpeedTest />
      <Spreader>
        <Anchor section={SECTIONS.INTERVIEW} />
        <TextBlock title="Геворк Вермишян: «Мы объединились для развития нового стандарта связи в России»">
          <Image type="video-preview" />
          <b>
            Мы хотели бы начать интервью, пожалуй, с главной новости в сфере 5G:
            МегаФон, «Ростелеком», «Вымпелком» и МТС подписали меморандум о
            намерениях по созданию совместного предприятия, которое будет
            заниматься расчисткой радиочастотного спектра и координацией
            внедрения 5G в России. Что это значит для рынка и как повлияет на
            запуск новой технологии?
          </b>
          <br />
          <br />
          Это действительно важное событие для рынка. Мы договорились совместно
          провести ряд мероприятий, которые позволят выявить достаточный и
          доступный радиочастотный ресурс для развития сетей пятого поколения во
          всех регионах России. Формат работы предприятия подразумевает
          совместное использование инфраструктуры для более полного покрытия
          территорий связью. Это привычная схема работы для операторов:
          например, МегаФон и «Вымпелком» использовали ее для развития LTE в
          нескольких регионах.
          <br />
          <br />
          Каждый из участников обладает необходимой сетевой инфраструктурой и
          опытом реализации проектов разного уровня сложности. Были проведены
          успешные пилоты в разных регионах России, демонстрирующие возможности
          связи нового поколения и ее применения. Мы объединили свои усилия для
          развития нового стандарта связи в России.
          <br />
          <br />
          <b>
            Тем не менее, насколько я понимаю, все еще нет полноценного
            стандарта 5G. Накладывает ли это какой-то отпечаток на
            подготовительные работы для внедрения 5G? Нет ли здесь рисков, что
            «готовились к одному, а согласовали другой»?
          </b>
          <br />
          <br />
          МегаФон первым из телеком-операторов начал работу по развертыванию
          5G в России еще пять лет назад. Были подписаны соглашения с вендорами,
          показано первое предкоммерческое оборудование для нового стандарта. Мы
          тестировали технологические возможности 5G, корректность
          функционирования оборудования, работу новых сервисов. <br />
          <br />
          Например, мы показали, что облачный гейминг на 5G может исключить
          вопрос покупки дорогостоящих мощных компьютеров, потому что играть
          можно будет на обычном ноутбуке, уводя все технологические процессы с
          мощностей устройства в облака. Продемонстрировали, что находясь далеко
          от стадиона, можно наблюдать за игрой футболистов в режиме реального
          времени в формате виртуальной реальности. Мы показали применение 5G в
          медицине, когда диагностика пациентов проводится дома с помощью
          датчиков, а расшифровка исследования идет дистанционно в
          медучреждении. Развернули постоянную пилотную зону 5G на Воробьевых
          горах в Москве. <br />
          <br />
          Сейчас главная задача – получить частоты для развертывания 5G. <br />
          <br />
          <b>
            Согласно концепции развития в России связи 5G, в качестве
            приоритетного указан диапазон частот 3,4-3,8 ГГц. Почему это
            наилучший из возможных частотных диапазонов для 5G?
          </b>
          <br />
          <br />
          Для развертывания 5G необходимо сочетание широких полос и достаточно
          хорошего распространения сигнала. Основная полоса для сетей пятого
          поколения – 3,4-3,8 ГГц, ее еще называют «золотой диапазон» или
          C-band. 90% коммерческих запусков нового стандарта в мире было
          реализовано именно в C-band. Вендоры также разрабатывают оборудование
          в большинстве своем под этот диапазон. <br />
          <br />
          Новые технологии получат широкое распространение только в том случае,
          если будут доступны большинству потребителей. Если мы будем строить 5G
          в других частотах, это потребует более существенных затрат от
          операторов на оборудование, вендоров – на аппараты. Как следствие, это
          приведет к удорожанию самой технологии для конечного пользователя.{' '}
          <br />
          <br />
          В нашей стране 3,4-3,8 ГГц традиционно используется государственными
          службами и спутниковыми компаниями. Операторы связи разработали ряд
          предложений, как можно было бы высвободить эти частоты, например,
          вывести из крупных городов наземные станции спутниковой связи. В
          диалоге с другими операторами связи и с государством мы найдем
          решения, которые будут устраивать и регулятора, и бизнес. <br />
          <br />
          <b>
            «В недалеком будущем 5G трансформирует все», - говорит ваш коллега,
            CEO Verizon Ганс Вестберг. Как бы вы расшифровали его слова? Как, по
            вашему мнению, 5G изменит нашу жизнь, жизнь конечного пользователя?
          </b>
          <br />
          <br />
          5G может стать машиной времени, которая перенесет нас в новую
          реальность. Вы выбираете квартиру в доме, который еще не построен. На
          вас – AR/VR-шлем, который показывает вам и будущий дом, и детский сад
          во дворе, и выезд из микрорайона. Вы не полагаетесь на устный рассказ
          риелтора, а видите будущее своими глазами. <br />
          <br />
          Вы не паркуете свой автомобиль во дворе, машина делает это сама,
          ориентируясь в реальном времени на информацию, которую она получает с
          разных объектов. В дороге она обменивается данными со светофорами и
          кадрами с камер других авто, подсказывая вам, на что обратить
          внимание. Вы получаете картинку, которую видит водитель, едущий
          впереди, и понимаете, когда обгон будет наиболее безопасным.
          <br />
          <br />
          5G обеспечит прорыв в индустрии медиа и развлечений, даст возможность
          запускать прямые трансляции из любой точки с высочайшим качеством,
          передавать данные с высокой скоростью большому числу пользователей –
          на квадратном километре к сети может быть подключено до миллиона
          устройств. В качестве тестирования технологии мы проводили трансляцию
          футбольного матча в рамках Чемпионата мира по футболу в формате VR.
          Участники наблюдали за игрой в режиме реального времени, 5 специальных
          камер кругового обзора позволили обеспечить максимальное погружение и
          эффект присутствия на стадионе.
          <br />
          <br />
          Скорость передачи данных играет важную роль в развитии облачного
          гейминга. Современные игры с дополненной реальностью будут доступны на
          любых, в том числе мобильных, устройствах, ведь обработку сложной
          графики можно будет производить на удаленных серверах. <br />
          <br />
          Напоминает фантастические рассказы, но еще вчера мы пользовались
          интернетом через модем, который тратил время на «дозвон» оператору, а
          такси вызывали с помощью телефона, и то только чтобы съездить в
          аэропорт. Наши привычки за последние годы сильно изменились, и новые
          технологии стали двигателем процессов. 5G даст каждому из нас новые
          возможности, о которых сегодня мы даже не подозреваем.
          <br />
          <br />
          <b>
            С пользователями разобрались. А какие возможности и перспективы
            открываются перед операторами, перед вами как одним из основных
            участников процесса? Вопрос не праздный в свете того, что последние
            вынуждены проводить глубокую трансформацию своей инфраструктуры и
            бизнеса в целом, чтобы не оказаться лишь «трубой» для перекачки
            растущего трафика.
          </b>
          <br />
          <br />
          Предыдущие стандарты связи были больше ориентированы на пользователя,
          был фокус на качество связи, на увеличение скорости интернета, на
          объем передачи данных. Сейчас в кармане у каждого из нас – смартфон,
          более мощный, чем компьютеры десять лет назад. Мы спокойно работаем с
          их помощью, выходим в интернет в метро и качаем фильмы в самолете.
          Поэтому 5G – это в большей степени про бизнес, чем про частных
          пользователей, но сервисы и продукты, которые даст бизнес, будут, в
          конечном счете, ориентированы на пользователей. <br />
          <br />
          Многие крупные российские компании в России в последние годы строят
          свои экосистемы, больше не концентрируясь на одном направлении.
          МегаФон уже не просто поставщик услуг связи, а большая
          технологическая компания: мы предоставляем решения в сфере финтеха,
          видеоконтента, интернета вещей. И, развивая 5G в России, мы тоже будем
          фокусироваться на тех темах, направлениях, технологиях, которые нужны
          в стране, интересны бизнесу и будут востребованы у пользователей.
          <br />
          <br />
          <b>
            Есть мнение, что распространение сетей пятого поколения приведет к
            постепенной смерти Wi-Fi, потому что устройства всегда и везде будут
            иметь доступ к интернету, независимо от того, есть рядом роутер или
            нет. Согласны с этим? Если пофантазировать, какие еще технологии (и
            не только технологии) могут уйти в прошлое благодаря новым
            возможностям 5G?
          </b>
          <br />
          <br />
          Внедрение 5G действительно повлияет на сценарии использования
          интернета. На самом деле текущих скоростей достаточно, чтобы всегда
          пользоваться только мобильным интернетом. Однако в большом количестве
          офисов и квартир по-прежнему активно используется Wi-Fi. Простота,
          привычность, доступность по цене еще долго будут способствовать
          популярности этого вида связи.
          <br />
          <br />
          Какие-то технологии действительно уйдут в прошлое или
          трансформируются. Например, многие сферы производства будут
          автоматизированы, работники будут реже подвергать себя опасности на
          сложных участках, вместо условного обходчика путей появятся датчики,
          которые в реальном времени будут передавать данные. Если говорить об
          образовании – все активнее будут использоваться дистанционные курсы,
          когда, например, учитель высокого уровня дает лекционный материал, а в
          рабочих тетрадях в офлайне учащиеся работают, например, с начинающими
          учителями.
          <br />
          <br />
          Как анализы крови перешли из ручной в сферу машинной обработки
          результатов, так и другие исследования будут проводиться быстрее и с
          учетом огромного количества факторов. Можно будет даже устанавливать
          датчики, которые сообщат об ухудшении самочувствия человека до того,
          как он почувствует это, дав ему время принять меры.
          <br />
          <br />
          <b>
            Порядок сумм, которые должны будут вложить в развитие сетей 5G
            российские операторы связи, исчисляется сотнями миллиардов рублей.
            Так, согласно экспертной оценке, которую ранее приводил вице-премьер
            РФ Максим Акимов, затраты на развертывание этих сетей до 2030 г.
            составят 650 млрд руб. Куда конкретно пойдут эти деньги, на какие
            мероприятия? Что необходимо сделать помимо решения частотного
            вопроса и установки большего числа базовых станций, чтобы сети 5G
            заработали в стране?
          </b>
          <br />
          <br />
          Анализировать расходы будет целесообразно, когда будет решен вопрос с
          частотами. Если говорить не только об инфраструктуре, мы, например,
          вкладываем средства в развитие новых сервисов. Мы обратились к
          студентам и построили 5G-лабораторию в СПбГУ. Почему к студентам?
          Потому что они лучше всех понимают, как мы будем жить в будущем, они
          смотрят фильмы, читают фантастику, играют в игры и могут воплотить в
          жизнь ту реальность, которой пока не существует. За этим экспериментом
          мы наблюдаем с большим интересом.
          <br />
          <br />
          <b>
            Одна из главных проблем в свете будущего развития 5G в России,
            которая стоит перед участниками рынка: как будет решен вопрос с
            расчисткой частот. Нет ли у вас опасений, что из-за задержки с
            решением Россия может столкнуться (или уже сталкивается?) со
            значительным отставанием в технологическом развитии от других
            государств, где этот вопрос уже благополучно разрешен?
          </b>
          <br />
          <br />
          Да, во многих странах 5G уже запущен в коммерческом формате, хотя
          ситуация с получением частот у многих государств похожая, где-то
          удалось договориться, где-то операторов устроили частоты за пределами
          C-band. Мы учтем опыт первопроходцев во время своего запуска, это тоже
          важно.
          <br />
          <br />
          <b>К слову, какие страны продвинулись больше других в развитии 5G?</b>
          <br />
          <br />
          Коммерческую эксплуатацию 5G первой начала Южная Корея в апреле 2019
          года, это не удивительно – там одни из самых высоких в мире
          показателей проникновения смартфонов. В 2019 году запущены услуги 5G в
          странах Азии, Европы, Ближнего Востока и Северной Америки. Настоящий
          бум подключений к сетям 5G переживает Китай. Власти Японии планируют
          развернуть к Олимпиаде-2020 полномасштабную 5G-сеть.
          <br />
          <br />
          <b>
            Для разработки конкурентоспособных 5G-решений необходимы тысячи
            патентов, лицензий, десятки тысяч R&D-специалистов. Откровенно
            говоря, вряд ли Россия может обеспечить себя этим всем целиком, а
            значит, придется подключать зарубежных партнеров. Каким может быть
            решение у этой проблемы?
          </b>
          <br />
          <br />
          Вендоры сегодня уже предлагают созревшие решения, которые
          соответствуют сертификациям 3GPP и Международного Союза Электросвязи
          как оборудование пятого поколения. Мы выберем то оборудование, которое
          будет оптимальным по цене, качеству и функциональным особенностям, оно
          может быть как зарубежным, так и отечественным.
          <br />
          <br />
          <b>
            Что происходит со спросом на услуги и сервисы, качественный скачок в
            развитии которых позволит сделать 5G? Правильно ли я понимаю, что
            рынку и пользователям еще предстоит «созреть» и привыкнуть к новому
            стандарту и прямо сейчас спроса еще нет?
          </b>
          <br />
          <br />
          Да, этот рынок еще предстоит сформировать. Возвращаясь к сервисам
          такси: когда был придуман Uber, было понятно, что привычный способ
          заказа машин не оптимален ни для пассажиров, которые должны были ждать
          долго, ни для водителей, которые ездили вхолостую. Но потребовалось
          время, чтобы мы привыкли, что такси – это не сервис, которым ты
          пользуешься раз в год, что можно вернуться на такси из магазина, что
          это удобно, просто и адекватно по цене. Так будет и со многими другими
          сервисами.
          <br />
          <br />
          <b>
            Впрочем, если сейчас проблема спроса — вопрос дискуссионный, то в
            недалеком будущем, уже к 2028 г., сети связи 5G уже с трудом будут
            справляться с растущим объемом передачи данных, прогнозирует Bank of
            America Merrill Lynch (BofA). И уже меньше чем через десять лет
            должны появиться сети следующего поколения — 6G. Стоит ли России уже
            начинать беспокоиться о 6G? Или пока такого вопроса нет в повестке и
            хорошо бы для начала с 5G разобраться?
          </b>
          <br />
          <br />
          Стандарт шестого поколения будет основан на том базисе, который
          создаст пятое поколение. Мысли о том, чтобы перескочить сразу на
          следующий уровень, были и при запуске 3G, но и тогда, и сейчас есть
          эволюционная преемственность и обязательные шаги при переходе от
          поколения к поколению, в частности, 5G пока не может обойтись в своей
          работе без сетей связи 4G. А вот переход от поколения к поколению
          действительно становится все более динамичным, так что 6G, возможно,
          мы увидим раньше, чем кажется.
        </TextBlock>
      </Spreader>
      <Footer />
    </div>
  );
}

export default App;
